import { useEffect } from 'react';

const RELOAD_KEY = 'saficuts_sw_reload';
const MAX_RELOADS = 2;

function UpdateNotification() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) {
      return;
    }

    // Reload-Loop-Schutz: sessionStorage überlebt Reloads, aber nicht Tab-Schließen
    const reloadCount = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10);
    if (reloadCount >= MAX_RELOADS) {
      console.warn('SW Update: Max reloads erreicht, kein weiterer Auto-Reload');
      return;
    }

    const doReload = (source) => {
      console.log(`🔄 ${source} - Reload ${reloadCount + 1}/${MAX_RELOADS}`);
      sessionStorage.setItem(RELOAD_KEY, String(reloadCount + 1));
      window.location.reload();
    };

    const activateAndReload = (worker, source) => {
      worker.postMessage({ type: 'SKIP_WAITING' });
      setTimeout(() => doReload(source), 500);
    };

    const autoUpdate = async () => {
      try {
        const registration = await navigator.serviceWorker.ready;

        // Prüfe ob bereits ein Update wartet
        if (registration.waiting) {
          activateAndReload(registration.waiting, 'Wartendes Update gefunden');
          return;
        }

        // Listener für neue Updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              activateAndReload(newWorker, 'Neues Update installiert');
            }
          });
        });

      } catch (error) {
        console.error('Service Worker Setup Fehler:', error);
      }
    };

    autoUpdate();

    // Bei erfolgreicher Kontrolle durch neuen SW: Reload-Counter zurücksetzen
    const handleControllerChange = () => {
      sessionStorage.removeItem(RELOAD_KEY);
    };
    navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);

    return () => {
      navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
    };
  }, []);

  return null;
}

export default UpdateNotification;
